import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import s from './FeaturedTag.scss';

interface Props {
  className?: string;
}

/** A featured indicator to be used when a comment has been featured. */
const FeaturedTag: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <span className={c(s['root'], className)}>
      {t('comment.visibility.featuredV2')}
    </span>
  );
};
FeaturedTag.displayName = 'FeaturedTag';

export default FeaturedTag;
